
interface PayslipCouncilHeaderProps {
  council?: string;
  payPeriod?: string;
}

export const PayslipCouncilHeader = ({ council, payPeriod }: PayslipCouncilHeaderProps) => {
  return (
    <div className="p-6 my-2 bg-gray-200 border b border-gray-400 rounded-md">
      <div className="flex justify-between items-center">
        <div className="text-right">
          <img src="assets/Coat_of_arms_of_Zambia.svg.png" alt="Council Logo" className='h-20 w-20'/>
        </div>
        <div className='text-center'>
          <h2 className="text-2xl font-bold text-payroll-primary">{council || 'Mwansabombwe Town Council'}</h2>
          <p className="text-lg text-gray-500">Pay Statement Month: {payPeriod}</p>
        </div>
        <div className="text-right">
          <img src="assets/logo1.png" alt="Council Logo" className='h-20 w-20'/>
        </div>
      </div>
    </div>
  );
};
